/**
 * Kabul edilen hukuk metinlerinin sürümü.
 *
 * Metinlerden biri esaslı biçimde değişince bu değer artırılır; o andan sonra mevcut
 * kullanıcılardan yeniden onay istenir. Zaman damgası tek başına "neyi kabul etti"
 * sorusunu cevaplamaz, bu yüzden sürüm rızayla birlikte saklanır.
 *
 * Tarih biçimi bilerek seçildi: hangi metin sürümünün yürürlükte olduğu bakınca anlaşılsın.
 */
export const CONSENT_VERSION = '2026-09-04';
/** Kullanıcının kayıtlı rızası güncel mi? Eksik veya eski sürümse yeniden onay gerekir. */
export function consentCurrent(u) {
    return u.consentVersion === CONSENT_VERSION && !!u.consentTermsAt;
}
//# sourceMappingURL=consent.js.map